import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: all 600ms;

  ${props =>
    props.direction === 'left' &&
    css`
      transform: translateX(${props.visible ? '0' : `${props.amount}px`});
    `}

  ${props =>
    props.direction === 'right' &&
    css`
      transform: translateX(${props.visible ? '0' : `-${props.amount}px`});
    `}

  ${props =>
    props.direction === 'up' &&
    css`
      transform: translateY(${props.visible ? '0' : `${props.amount}px`});
    `}

  ${props =>
    props.direction === 'down' &&
    css`
      transform: translateY(${props.visible ? '0' : `-${props.amount}px`});
    `}
`

class FadeEntry extends Component {
  static propTypes = {
    direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
    delay: PropTypes.number,
    scroll: PropTypes.bool,
    amount: PropTypes.number
  }

  static defaultProps = {
    direction: 'up',
    delay: 0,
    scroll: true,
    amount: 100
  }

  state = { visible: false }

  componentDidMount() {
    const { scroll, delay } = this.props

    if (scroll) {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll()
    } else {
      this.timeout = setTimeout(() => this.setState({ visible: true }), delay)
    }
  }

  componentWillUnmount() {
    if (this.props.scroll) {
      window.removeEventListener('scroll', this.handleScroll)
    }
    clearTimeout(this.timeout)
  }

  handleScroll = () => {
    const { delay } = this.props

    if (this.wrap) {
      const rect = this.wrap.getBoundingClientRect()
      if (rect.top < window.innerHeight && rect.bottom > 100) {
        this.timeout = setTimeout(() => this.setState({ visible: true }), delay)
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
  }

  render() {
    const { visible, amount } = this.state

    return (
      <Wrapper
        visible={visible}
        innerRef={el => {
          this.wrap = el
        }}
        amount={amount}
        {...this.props}
      />
    )
  }
}

export default FadeEntry



// WEBPACK FOOTER //
// ./src/ui/components/generic/FadeEntry.js